<template>
    <div class="categoryList">
        <div class="img">
            <img :src="data.imgPath" alt="">
        </div>
        
        <div class="text" v-if="data.dataType != 'Live'">
            <div class="title" v-text="data.title"></div>
            <div class="teach" v-if="data.teachArr.length !== 0">
                <p v-for="(item,i) in data.teachArr" :key="i" v-text="item" v-if="i <= 2"></p>
                <div class="information">
                    <span class="money" v-text="'￥' + data.money"></span>
                    <span class="frequency"><em class="iconfont icon-bofang"></em> <em v-text="data.redu"></em></span>
                    <span class="class-hour"><em class="iconfont icon-kechengbiao"></em><em v-text="data.keshi"></em>课时</span>
                </div>
            </div>
            <div v-else-if="data.payed" class="myvideoLi">
                <div class="information videoDel" v-if="data.jieName==''">
                    <span class="frequency"><em class="iconfont icon-bofang"></em> <em v-text="data.redu"></em></span>
                    <span class="class-hour"><em class="iconfont icon-kechengbiao"></em><em v-text="data.keshi"></em>课时</span>
                </div>
                <div v-else><span class="jieName twoEllipsis" v-text="data.jieName"></span></div>
                <div class="payinfo">
                    <span class="payed" v-if="data.payed" v-text="'已购买'"></span>
                </div>
            </div>
            <div v-else>
                <div class="information">
                        <span class="frequency" v-if="data.redu !== 'none'"><em class="iconfont icon-bofang"></em> <em v-text="data.redu"></em></span>
                        <span class="class-hour"><em class="iconfont icon-kechengbiao"></em><em v-text="data.keshi"></em>课时</span>
                </div>
                <div class="information">
                        <span class="money" v-if="data.money" v-text="'￥' + data.money"></span>
                </div>
            </div>
            <div class="line" v-if="!data.payed">
                <div></div>
            </div>
        </div>

        <div class="text" v-else-if="data.dataType == 'Live'">
            <div class="title" v-text="data.title"></div>
            <div class="teach" v-if="data.teachArr.length !== 0">
                <p v-for="(item,i) in data.teachArr" :key="i" v-text="item" v-if="i <= 2"></p>
                <div class="information">
                    <span class="money" v-text="data.money"></span>
                </div>
            </div>
            <div v-else-if="data.payed" class="myvideoLi">
                <div class="payinfo">
                    <span class="payed" v-if="data.payed" v-text="data.money"></span>
                </div>
            </div>
            <div v-else>
                <div class="information">
                  <span class="money" v-if="data.money" v-text="data.money"></span>
                </div>
            </div>
            <div class="line" v-if="!data.payed">
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "categoryList",
  created() {},
  data() {
    return {};
  },
  methods: {},
  props: {
    data: {},
    content_type:'',
    url: {
      default: "/"
    }
  }
};
</script>

<style scoped lang="scss">
.lecturer{
  margin-top: 10px;
  font-size: 16px;
  span {
    margin-left: 15px;
  }
  em {
    font-size: 26px;
    display: inline-block;
    margin: 0 3px;
    color: #999999;
    line-height: 1;
  }
}
.headerDesc{
  margin-top: 18px;
  margin-bottom: 15px;
  font-size: 30px;
  .money {
    font-size: 30px;
    color: #ff8004;
    line-height: 1;
  }
  span {
    margin-right: 40px;
  }
  em {
    font-size: 26px;
    display: inline-block;
    margin: 0 3px;
    color: #999999;
    line-height: 1;
  }
}
.bottomDescription{
  /*height: 40px;*/
  /*line-height: 40px;*/
  margin-top: 28px;
  font-size: 30px;
  .money {
    font-size: 30px;
    color: #ff8004;
    line-height: 1;
  }
  span {
    margin-right: 40px;
  }
  em {
    font-size: 26px;
    display: inline-block;
    margin: 0 3px;
    color: #999999;
    line-height: 1;
  }
}
.information {
  /*height: 40px;*/
  /*line-height: 40px;*/
  margin-top: 38px;
  font-size: 30px;
  .money {
    font-size: 30px;
    color: #ff8004;
    line-height: 1;
  }
  span {
    margin-right: 40px;
  }
  em {
    font-size: 26px;
    display: inline-block;
    margin: 0 3px;
    color: #999999;
    line-height: 1;
  }
}
.myvideoLi {
  font-size: 24px;
}
.payinfo {
  font-size: 24px;
  margin-top: 10px;
}
.videoDel {
    min-height: 80px;
  margin-top: 20px;
}
.jieName {
  display: block;
  min-height: 80px;
  font-size: 26px;
  color: #999;
  margin-top: 14px;
}
.payed {
  color: #ff8004;
  font-size: 24px;
}
.categoryList {
  position: relative;
  width: 100%;
  padding: 30px 0;
  box-sizing: border-box;
  cursor: pointer;
}
.img {
  width: 200px;
  background: pink;
  height: 200px;
    img{
        width: 100%;
       height: 100%;
    }
}
.text {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding-left: 220px;
  overflow: hidden;
  .line {
    width: 100%;
    box-sizing: border-box;
    padding-left: 220px;
    overflow: hidden;
    div {
      width: 100%;
      box-sizing: border-box;
      margin-left: -220px;
      border-bottom: 1PX solid #e1e1e1;
    }
    position: absolute;
    bottom: 0;
  }
  .title {
    font-size: 30px;
    margin-top: 43px;
    color: #333;
    font-weight: bold;
    line-height: 1.2;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .teach {
    line-height: 1;
    font-size: 0;
    height: auto;
    margin-top: 20px;
    p {
      font-size: 24px;
      margin-right: 10px;
      text-align: center;
      color: #999;
      background: #f6f7f8;
      padding: 0 30px;
      display: inline-block;
      border-radius: 22px;
      line-height: 44px;
    }
  }

  .lector {
    line-height: 1;
    font-size: 0;
    height: auto;
    margin-top: 15px;
    p {
      font-size: 24px;
      margin-right: 10px;
      text-align: center;
      color: #999;
      // background: #f6f7f8;
      padding: 0 30px;
      display: inline-block;
      // border-radius: 22px;
      line-height: 44px;
    }
  }
}
.class-hour {
  color: #999;
}
</style>
